import { useEffect } from "react"
import { isMotionReduced, loadSettings } from "../game/settings"

/**
 * The page turning between loops. Because every surface in this game is
 * parchment and ink, a reset should look like one: an aged leaf sweeps across
 * as the old loop's ink lifts off it, the wheel-turns legend is penned in gold,
 * and the veil withdraws to leave a fresh page beneath — the awakening the
 * player wakes into. It is the one deliberate beat of the whole loop, so it is
 * allowed a full two seconds; under prefers-reduced-motion it collapses to a
 * brief fade instead (matched here and in the stylesheet).
 */
export function LoopTransition({
  loopNumber,
  onDone,
}: {
  loopNumber: number
  onDone: () => void
}) {
  useEffect(() => {
    // The page-turn collapses to a brief fade when animation is trimmed or
    // stilled — by the player's setting or their system's reduce-motion request.
    const reduced = isMotionReduced(loadSettings())
    const timer = window.setTimeout(onDone, reduced ? 420 : 2100)
    return () => window.clearTimeout(timer)
  }, [onDone])

  return (
    <div className="loop-transition" role="presentation" aria-hidden="true">
      <div className="loop-transition-veil" />
      <div className="loop-transition-plate">
        <span className="loop-transition-rule" />
        <p className="loop-transition-legend">The wheel turns again</p>
        <p className="loop-transition-loop">Loop {loopNumber}</p>
        <span className="loop-transition-rule" />
      </div>
    </div>
  )
}
